import React from 'react';
import AdminConsoleLayout from './AdminConsoleLayout';
import UserManagement from '../UserManagement';

/**
 * User Management Page with Admin Console Layout
 */
const UserManagementPage = () => {
  return (
    <AdminConsoleLayout>
      <UserManagement />
    </AdminConsoleLayout>
  );
};

export default UserManagementPage;
